import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const SentryCloudService = {
    getCloneStatus: async (params) => axios.get(`${API_KEEPER}/interligation/configuration`, { params: params ?? {} }).then(({ data }) => data).catch((err) => { throw err }),

    saveCloneStatus: async (data) => axios.post(`${API_KEEPER}/interligation/configuration`, data, {headers: {'Content-Type': 'application/json'}}).then(({data}) => data).catch((err) => { throw err }),

    getCloneConfig: async (params) => axios.get(`${API_KEEPER}/interligation/cloneConfiguration`, { params: params ?? {}}).then(({ data }) => data).catch((err) => { throw err }),

    saveCloneConfig: async (data) => axios.post(`${API_KEEPER}/interligation/cloneConfiguration`, data, { headers: { 'Content-Type': 'application/json' }}).then(({ data }) => data).catch((err) => { throw err }),
};

export default SentryCloudService;